import React, { useState } from "react";
import useFetch from '../../hooks/useFetch'
import { Modal, Button, LoadingIcon } from '@prosolve/common-components-ui'
import { 
  getClientSubdomain, 
} from '../../utils';

export default ({
  eventData = {},
  onClose,
  onSuccess,
}) => {
  const clientSubdomain = getClientSubdomain()
  const isStarSubdomain = (clientSubdomain === 'star')

  const {
    trainerId = '',
    projectStatus = '',
  } = eventData;

  const [isBusy, setIsBusy] = useState(false);

  const options = ['Accept', 'Decline']

  const [selectedOption, setSelectedOption] = useState('');

  const fetch = useFetch()

  const onClickSubmit = async () => {
    if (!isBusy && selectedOption) {
      setIsBusy(true)

      const data = {
        trainerId,
        trainerRequestStatus: selectedOption === 'Decline' ? 'Declined' : ( projectStatus === 'Tentative' ? 'Tentatively Booked' : 'Booked')
      }

      try {
        const response = await fetch(`events/event/trainers/update`, {
          method: 'POST',
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ data })
        })
        const jsonData = await response.json()

        console.log(jsonData)

        if (jsonData.success) {
          setIsBusy(false)
          onSuccess()
        }
      } catch (e) {
        console.log(e)
      }

      setIsBusy(false)

      onClose()
    }
  }

  const footer = (
    <div style={{ 
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px',
      position: 'relative'
    }}>
      {
        isBusy &&
        <div style={{ position: 'absolute', left: '32px'}}>
          <LoadingIcon  />
        </div>
      }
      <Button onClick={() => !isBusy && onClose()} $disabled={isBusy}>
        {'Cancel'}
      </Button>
      <Button onClick={onClickSubmit} $colored={true} $disabled={isBusy}>
        {'Submit'}
      </Button>
    </div>
  )

  return (
    <Modal title={'Respond To Trainer Invitation'} isAutoHeight={true} onClose={() => !isBusy && onClose()} footer={footer}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '15px'
      }}>
        <div style={{
          color: '#565656',
          fontSize: '14px',
          fontStyle: 'italic'
        }}>
          {
            isStarSubdomain ? 
            'Please either accept or decline this event. If you have logistical questions prior to accepting/declining, please reach out to scheduling via email. If you choose to decline, provide more information in the auto-generated Teams message.' 
            :
            '*Please select a response below and then click submit to either accept or decline this trainer invitation:'
          }
        </div>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          rowGap: '15px',
          columnGap: '15px',
          flexWrap: 'wrap'
        }}>
          {
            options.map(option => {
              const isSelected = selectedOption === option;
              const isRed = option === 'Decline';
              return (
                <div
                  key={option}
                  style={{
                    padding: '8px 12px 6px 12px',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                    // background: isSelected ? (isRed ? '#ef0c0c' : '#0280c6') : '#7e7e7e',
                    // color: '#ffffff',
                    // border: '1px solid #565656',
                    color: isSelected ? (isRed ? '#ef0c0c' : '#0280c6') : '#7e7e7e',
                    border: isSelected ? (isRed ? '2px solid #ef0c0c' : '2px solid #0280c6') : '2px solid transparent',
                    borderRadius: '5px',
                    position: 'relative',
                    top: '1px'
                  }}
                  onClick={() => {
                    if (selectedOption !== option) {
                      setSelectedOption(option)
                    }
                  }}
                >
                  {option}
                </div>
              )
            })
          }
        </div>
      </div>
    </Modal>
  )
}